/**
 * Resolve the set of analytics provider serviceNames the browser may register, from
 * the backend-supplied allow-list on the current cluster (computed by the backend
 * `AnalyticsControlsService`). The client holds no tiering policy — it only honours
 * this list.
 *
 * Trust the config-store cluster only when its `code` matches the authoritatively
 * resolved cluster code (from the `X-Cluster-Code` header via `router.options.ts`).
 * An unresolved host (missing / unknown header) leaves the config store defaulted to
 * `clusters[0]` — a consumer cluster with a full allow-list — so a schools host whose
 * code did not resolve would otherwise register marketing providers. Any mismatch, or
 * a missing cluster / list, yields an empty set: registration fails closed.
 */
export const resolveAllowedAnalyticsProviders = (
  resolvedClusterCode: string | null,
  cluster: { code: string; allowedAnalyticsProviders: string[] } | null | undefined,
): Set<string> =>
  new Set(resolvedClusterCode && cluster?.code === resolvedClusterCode ? cluster.allowedAnalyticsProviders : []);
